export default function getHost() {
  return window.location.href.indexOf('localhost') > -1 ? 'http://localhost:8080' : '';
}
